import { render, staticRenderFns } from "./TenantSelect.vue?vue&type=template&id=79ff378c&"
import script from "./TenantSelect.vue?vue&type=script&lang=js&"
export * from "./TenantSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports